export default function registerPolyline (lf) {
  lf.register('polyline', ({ PolylineEdge, PolylineEdgeModel }) => {
    class ConnnectionModel extends PolylineEdgeModel {
      constructor (data, graphModel) {
        super(data, graphModel)
      }

      setAttributes() {

        const properties = this.getProperties()
        this.isAnimation =properties.exp==="true"?true:false;

      }
      setHovered (isHovered) {
        const properties = this.getProperties()
        super.setHovered(isHovered);
        if (isHovered)
        this.isAnimation = isHovered;
        else {
          const properties = this.getProperties()
          this.isAnimation =properties.exp==="true"?true:false;

        }
      }
      getEdgeStyle() {
        const properties = this.getProperties()

        const _style=properties.style;
        const style = super.getEdgeStyle();
        style.stroke =_style?_style.borderColor: "#6c98ad";
        if (_style && _style.borderStyle==="dashed") style.strokeDasharray = "3 3";
        if (_style && _style.borderWidth) style.strokeWidth=_style.borderWidth;

        return style;
      }
      getEdgeAnimationStyle() {
        const properties = this.getProperties()

        const _style=properties.style;
        const style = super.getEdgeAnimationStyle();
        style.stroke =_style?_style.borderColor: "#ad0d14";
        style.animationName = "lf_animate_dash"
        return style;
      }
    }
    return {
      view: PolylineEdge,
      model: ConnnectionModel
    }
  })
}
